import type { ReactNode } from "react";

export interface LegendEntry {
  key: string;
  label: string;
  color: string;
  value?: string;
}

interface ChartCardProps {
  title: string;
  subtitle?: string;
  headline?: string;
  headlineCaption?: string;
  legend?: LegendEntry[];
  empty?: boolean;
  emptyLabel?: string;
  children: ReactNode;
}

export const ChartCard = ({
  title,
  subtitle,
  headline,
  headlineCaption,
  legend,
  empty,
  emptyLabel,
  children,
}: ChartCardProps) => (
  <section className="chart-card">
    <div className="chart-card__head">
      <div>
        <h3 className="chart-card__title">{title}</h3>
        {subtitle ? <p className="chart-card__sub">{subtitle}</p> : null}
      </div>
      {headline ? (
        <div className="chart-card__headline">
          <span className="chart-card__headline-value">{headline}</span>
          {headlineCaption ? (
            <span className="chart-card__headline-caption">{headlineCaption}</span>
          ) : null}
        </div>
      ) : null}
    </div>

    <div className="chart-card__body">
      {empty ? (
        <p className="chart-card__empty">{emptyLabel ?? "No data yet."}</p>
      ) : (
        children
      )}
    </div>

    {legend?.length && !empty ? (
      <ul className="chart-legend">
        {legend.map((entry) => (
          <li className="chart-legend__item" key={entry.key}>
            <span
              className="chart-legend__swatch"
              style={{ background: entry.color }}
            />
            <span className="chart-legend__label">{entry.label}</span>
            {entry.value ? (
              <span className="chart-legend__value">{entry.value}</span>
            ) : null}
          </li>
        ))}
      </ul>
    ) : null}
  </section>
);
